<template>
    <form class="form" @submit.prevent="emitEvent({ name: 'form-submit', payload: $event })">
        <slot></slot>

        <template v-if="$slots.footer">
            <div class="form__footer">
                <slot name="footer"></slot>
            </div>
        </template>
    </form>
</template>

<script>
    export default {
        props: {
            isSubmittable: { type: Boolean, default: true },
        },
    }
</script>
